import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import './BaseChip.css';
import './ChipKey.css';
export var key = '_1pehkco1-3-12-1';